// generated from 373 samples

import { z } from "zod";

export const cartUpdatedEventTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::CartUpdatedEvent"),
});
